var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"margin-bottom":"150px"},attrs:{"flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{on:{"click":_vm.fetchMemberCategories}},[_vm._v("memba cat")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }